function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Upload, Alert, Button, notification } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EditUserAvatar = function EditUserAvatar(_ref) {
  var user = _ref.user;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLogoAdded = _useState2[0],
    setIsLogoAdded = _useState2[1];
  var _useState3 = useState([{
      uid: '-1',
      name: 'image.png',
      status: 'done',
      url: Common.baseUrl + Common.currentUser.avatar
    }]),
    _useState4 = _slicedToArray(_useState3, 2),
    fileList = _useState4[0],
    setFileList = _useState4[1];
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    uploadStatus = _useState6[0],
    setUploadStatus = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    serverResponse = _useState8[0],
    setServerResponse = _useState8[1];
  var onChange = function onChange(_ref2) {
    var newFile = _ref2.file,
      newFileList = _ref2.fileList,
      e = _ref2.event;
    if (fileList.length > 1) return;
    setFileList(newFileList);
    //console.log(e.toString());  
    if (newFile.status === 'done') {
      setServerResponse(newFile.response.message);
      if (newFile.response.status == '200') {
        setIsLogoAdded(true);
      } else {
        setUploadStatus(0);
      }
    }
  };
  var onPreview = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
      var src, image, imgWindow;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            src = file.url;
            if (src) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return new Promise(function (resolve) {
              var reader = new FileReader();
              reader.readAsDataURL(file.originFileObj);
              reader.onload = function () {
                return resolve(reader.result);
              };
            });
          case 1:
            src = _context.v;
          case 2:
            image = new Image();
            image.src = src;
            imgWindow = window.open(src);
            imgWindow.document.write(image.outerHTML);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onPreview(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onRemove = function onRemove(file) {
    axios.get(Common.baseApiUrl + 'deleteuseravatar/' + user.id.toString()).then(function (response) {
      if (response.data.status == 200) {
        notification.success(_defineProperty({
          message: "Ok"
        }, "message", response.data.message));
      } else {
        notification.error(_defineProperty({
          message: "Oops!"
        }, "message", response.data.message));
        setFileList([file]);
      }
    })["catch"](function (error) {
      notification.error(_defineProperty({
        message: "Oops!"
      }, "message", "Une erreur est survenue"));
      setFileList([file]);
    });
  };
  useEffect(function () {}, []);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      textAlign: 'center'
    },
    children: [/*#__PURE__*/_jsx(ImgCrop, {
      rotate: true,
      children: /*#__PURE__*/_jsx(Upload, {
        action: Common.baseApiUrl + 'setuseravatar/' + user.id.toString(),
        listType: "picture-card",
        fileList: fileList,
        name: "avatar",
        onChange: onChange,
        onPreview: onPreview,
        onRemove: onRemove,
        children: fileList.length < 1 && '+ Photo'
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), isLogoAdded ? /*#__PURE__*/_jsx(Alert, {
      banner: true,
      closable: true,
      style: {
        marging: '5px 0px',
        fontSize: '14px'
      },
      message: serverResponse,
      type: "success",
      showIcon: true
    }) : /*#__PURE__*/_jsx("span", {}), uploadStatus == 0 ? /*#__PURE__*/_jsx(Alert, {
      banner: true,
      closable: true,
      style: {
        marging: '5px 0px',
        fontSize: '14px'
      },
      message: serverResponse,
      type: "error",
      showIcon: true
    }) : /*#__PURE__*/_jsx("span", {})]
  });
};
export default EditUserAvatar;